import React from "react";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";

const GalleryModal = ({
  show,
  onHide,
  selectedFiles,
  onFilesSelect,
  onRemoveFile,
  onSubmit,
  isUploading,
}) => {
  return (
    <Modal className="commn-modal-css" show={show} onHide={onHide} size="md">
      <Modal.Header className="border-0" closeButton></Modal.Header>
      <Modal.Body className="pt-0">
        <h2 className="mb-3">Add Images/Videos to Gallery</h2>
        <div className="mb-3">
          <input
            type="file"
            accept="image/*,video/*"
            multiple
            onChange={(e) => {
              const files = Array.from(e.target.files);
              if (selectedFiles.length + files.length > 5) {
                toast.error("Maximum 5 files allowed");
                return;
              }
              onFilesSelect(e);
            }}
            className="form-control"
          />
        </div>

        {selectedFiles.length > 0 && (
          <div>
            <h6>Selected Files:</h6>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                gap: "10px",
              }}
            >
              {selectedFiles.map((fileData, index) => (
                <div key={index} style={{ position: "relative" }}>
                  {fileData.type === "video" ? (
                    <video
                      src={fileData.preview}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                      }}
                      controls
                    />
                  ) : (
                    <img
                      src={fileData.preview}
                      alt={`Preview ${index}`}
                      style={{
                        width: "100%",
                        height: "150px",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  <button
                    onClick={() => onRemoveFile(index)}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "red",
                      color: "white",
                      border: "none",
                      borderRadius: "50%",
                      width: "25px",
                      height: "25px",
                      cursor: "pointer",
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end gap-2 comnn-modal-action">
          <button className="outline" onClick={onHide}>
            Cancel
          </button>
          <button
            className="fill"
            onClick={() => {
              if (selectedFiles.length === 0) {
                toast.error("Please select at least one file");
                return;
              }
              onSubmit();
            }}
            disabled={isUploading}
          >
            {isUploading ? "Uploading..." : "Upload to Gallery"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default GalleryModal;
